<template>
  <!-- Wrapper expects Bootstrap 5 loaded globally -->
  <section class="uo-hero-v2">
    <div class="container">
      <div class="row align-items-center">
        <!-- 左標題 -->
        <div class="col-md-8 text-start">
          <h1 class="uo-hero-main">
            <span class="uo-yellow">Why Choose</span><br />
            <span class="uo-white">Union Ocean?</span>
          </h1>
        </div>

        <!-- 垂直分隔線 -->
        <div class="col-md-1 d-none d-md-flex justify-content-center">
          <div class="uo-divider"></div>
        </div>

        <!-- 右說明 -->
        <div class="col-md-2 text-md-start text-center mt-4 mt-md-0">
          <div class="uo-hero-desc">
            <p class="uo-yellow mb-0">A Team with</p>
            <p class="uo-yellow mb-0">Combined Educational</p>
            <p class="uo-yellow mb-0">Experience Totaling</p>
            <p class="uo-white-bold mt-2">over<br />80 Years</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 數據區塊 -->
  <section class="uo-stats">
    <div class="container">
      <div class="row text-center">
        <div class="col-6 col-md-2 mb-4">
          <h2 class="uo-stat-number">500+<br /></h2>
          <h3 class="uo-stat-unit-blank">口</h3>
          <p class="uo-stat-label">Institutions<br />合作學校</p>
        </div>
        <div class="col-6 col-md-2 mb-4">
          <h2 class="uo-stat-number">20+</h2>
          <h3 class="uo-stat-unit">Years</h3>
          <p class="uo-stat-label">Sales Experience<br />業界經歷</p>
        </div>
        <div class="col-6 col-md-2 mb-4">
          <h2 class="uo-stat-number">200+</h2>
          <h3 class="uo-stat-unit-blank">口</h3>
          <p class="uo-stat-label">Products<br />產品</p>
        </div>
        <div class="col-6 col-md-2 mb-4">
          <h2 class="uo-stat-number">40+</h2>
          <h3 class="uo-stat-unit-blank">口</h3>
          <p class="uo-stat-label">Publishers<br />出版社</p>
        </div>
        <div class="col-6 col-md-2 mb-4">
          <h2 class="uo-stat-number">50+</h2>
          <h3 class="uo-stat-unit-blank">口</h3>
          <p class="uo-stat-label">Workshops<br />工作坊</p>
        </div>
        <div class="col-6 col-md-2 mb-4">
          <h2 class="uo-stat-number">80+</h2>
          <h3 class="uo-stat-unit">Years</h3>
          <p class="uo-stat-label">Experience<br />教學經歷</p>
        </div>
      </div>
    </div>
  </section>

  <!-- 市占圖 / We Serve v3 -->
  <!-- We Serve - Image Only -->
  <section class="uo-serve-images">
    <div class="container">
      <div class="row g-0 align-items-center">
        <!-- 左圖 -->
        <div class="col-md-6 uo-col-img uo-col-left">
          <img
            src="../assets/img-1/AboutUs/we-serve-left.png"
            class="uo-img img-fluid"
            alt="We Serve Left"
          />
        </div>

        <!-- 右圖 -->
        <div class="col-md-6 uo-col-img uo-col-right">
          <img
            src="../assets/img-1/AboutUs/we-serve-right.png"
            class="uo-img img-fluid"
            alt="We Serve Right"
          />
        </div>
      </div>
    </div>
  </section>

  <!-- 詳細條列區（整齊版） -->
  <section class="uo-detail-dual">
    <div class="container">
      <!-- 區塊 1：Market Coverage -->
      <div class="uo-detail-block">
        <h4 class="uo-section-title">
          Market Coverage <span class="uo-subtext">市場涵蓋範圍</span>
        </h4>
        <div class="row">
          <!-- 條列 A -->
          <div class="col-md-6">
            <div class="uo-item">
              <img
                src="../assets/img-1/AboutUs/school.png"
                class="uo-icon"
                alt="Institution"
              />
              <div class="uo-item-body">
                <div class="uo-number-inline">500⁺</div>
                <!-- <span class="uo-number-unit"> pcs</span> -->
                <p class="uo-text">
                  服務超過 500
                  所學校、圖書館及教育機構，協助媒合資源，支援教材推薦與課程搭配。
                </p>
              </div>
            </div>
          </div>
          <!-- 條列 B -->
          <div class="col-md-6">
            <div class="uo-item">
              <img
                src="../assets/img-1/AboutUs/schedule.png"
                class="uo-icon"
                alt="Calendar"
              />
              <div class="uo-item-body">
                <div class="uo-number-inline">20⁺</div>
                <span class="uo-number-unit"> yrs</span>
                <p class="uo-text">
                  超過 20
                  年產業經驗累積，提供專業教學建議，服務全台學校、圖書館、學習中心及教育單位。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 區塊 2：Global Reach -->
      <div class="uo-detail-block">
        <h4 class="uo-section-title">
          Global Reach & Partnerships
          <span class="uo-subtext">全球佈局與合作夥伴關係</span>
        </h4>
        <div class="row">
          <!-- 條列 A -->
          <div class="col-md-6">
            <div class="uo-item">
              <img
                src="../assets/img-1/AboutUs/global.png"
                class="uo-icon"
                alt="Global"
              />
              <div class="uo-item-body">
                <div class="uo-number-inline">200⁺</div>
                <!-- <span class="uo-number-unit"> pcs</span> -->
                <p class="uo-text">
                  獨家代理HMH、VISTA優質英語教材，合作超過 200
                  種國際教育產品線，包含教材、教具、平台與教學資源。
                </p>
              </div>
            </div>
          </div>
          <!-- 條列 B -->
          <div class="col-md-6">
            <div class="uo-item">
              <img
                src="../assets/img-1/AboutUs/book.png"
                class="uo-icon"
                alt="Books"
              />
              <div class="uo-item-body">
                <div class="uo-number-inline">40⁺</div>
                <!-- <span class="uo-number-unit"> pcs</span> -->
                <p class="uo-text">
                  與超過 40
                  家國際知名出版社建立合作關係，涵蓋語言學習、閱讀、數理、科學、跨學科等領域。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 區塊 3：Team Events -->
      <div class="uo-detail-block">
        <h4 class="uo-section-title">
          Team Events & Professionalism
          <span class="uo-subtext">團隊活動與專業素養</span>
        </h4>
        <div class="row">
          <!-- 條列 A -->
          <div class="col-md-6">
            <div class="uo-item">
              <img
                src="../assets/img-1/AboutUs/training.png"
                class="uo-icon"
                alt="Workshop"
              />
              <div class="uo-item-body">
                <div class="uo-number-inline">50⁺</div>
                <!-- <span class="uo-number-unit"> pcs</span> -->
                <p class="uo-text">
                  舉辦超過 50
                  場教師研習會，涵蓋品牌教材導覽和教材技巧分享。
                </p>
              </div>
            </div>
          </div>
          <!-- 條列 B -->
          <div class="col-md-6">
            <div class="uo-item">
              <img
                src="../assets/img-1/AboutUs/idea.png"
                class="uo-icon"
                alt="Idea"
              />
              <div class="uo-item-body">
                <span class="uo-number-inline">80⁺</span>
                <span class="uo-number-unit"> yrs</span>
                <p class="uo-text">
                  團隊成員擁有超過 80 年的教學與課程設計經驗，涵蓋
                  IB、ESL、STEM 等國際教學專業。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div id="AboutDown">
    <AboutDown/>
  </div>


</template>

<script>
import AboutDown from '../components/AboutDown.vue'


export default {
  components: {
    AboutDown,
  },
};
</script>

<style scoped>
/* 容器最大寬度 */
.container {
  max-width: 900px;
}

/* Hero 樣式 */
.uo-hero-v2 {
  background-color: #0c3f8d;
  color: white;
  padding: 80px 0;
}

.uo-hero-main {
  font-size: 38px;
  font-family: "Montserrat", sans-serif;
  font-weight: 900;
  line-height: 1.5;
}

.uo-yellow {
  color: #ffc107;
  font-weight: 1000;
}

.uo-white {
  color: #fff;
  font-weight: 1000;
}

.uo-white-bold {
  color: #fff;
  font-weight: 800;
  font-size: 24px;
  line-height: 1.6;
}

.uo-divider {
  border-left: 1px solid #144a99;
  height: 120px;
}

/* Hero：小螢幕置中排版 */
@media (max-width: 991.98px) {
  .uo-hero-v2 .col-md-8 {
    /* 左標題欄 */
    text-align: center !important;
  }
  .uo-hero-v2 .uo-hero-main {
    text-align: center;
    font-size: 34px; /* 可依需要微調 */
    line-height: 1.35;
  }

  .uo-hero-v2 .col-md-1 {
    /* 中間分隔線 */
    display: none !important;
  }

  .uo-hero-v2 .col-md-2 {
    /* 右側說明欄 */
    text-align: center !important;
    margin-top: 16px;
  }
  .uo-hero-v2 .uo-hero-desc {
    max-width: 420px;
    margin: 8px auto 0; /* 置中 */
  }

  .uo-hero-v2 {
    /* 視覺間距 */
    padding-top: 56px;
    padding-bottom: 48px;
  }
}

/* 數據區塊樣式 */
.uo-stats {
  background-color: #dbe9f7;
  padding: 60px 0;
}

.uo-stat-number {
  color: #003b8f;
  font-size: 32px;
  font-weight: 800;
  margin-bottom: -3px;
}

.uo-stat-unit {
  color: #003b8f;
  font-size: 15px;
  font-weight: 800;
}

.uo-stat-unit-blank {
  color: #DBE9F7;
  font-size: 15px;
  font-weight: 800;
}

.uo-stat-label {
  color: #003b8f;
  font-size: 14px;
  line-height: 1.5;
}

/* We Serve v3 */
/* 只用圖片的雙欄版 */
.uo-serve-images {
  background: #eee7dd; /* 底色跟你設計一致 */
  padding: 60px 0;
}

.uo-col-img {
  position: relative;
  min-height: 520px; /* 讓兩邊高度一致、圖片有呼吸空間 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.uo-col-left {
  border-right: 1px solid rgba(0, 0, 0, 0.06); /* 中間細分隔線 */
}

.uo-img {
  max-width: 100%;
  max-height: 65vh; /* 不要超出視窗 */
  object-fit: contain; /* 完整置入 */
  display: block;
}

/* RWD：手機直向改為上下堆疊，拿掉中線並加點間距 */
@media (max-width: 991.98px) {
  .uo-col-img {
    min-height: auto;
    padding: 16px 12px 28px;
  }
  .uo-col-left {
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    margin-bottom: 8px;
    padding-bottom: 24px;
  }
  .uo-img {
    max-height: 64vh;
  }
}

/* 兩欄 We Serve 區塊 
.uo-serve-two-column {
  background-color: #EEE7DD;
  padding: 80px 0;
}

.uo-detail-title {
  font-size: 26px;
  font-weight: 800;
  color: #ffffff;
}

.uo-subheading {
  color: #003B8F;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 6px;
}

.uo-number {
  color: #F5AF00;
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 4px;
}

.uo-desc {
  font-size: 15px;
  line-height: 1.5;
  color: #222;
}

.uo-img-taiwan {
  width: 100%;
  max-width: 180px;
  opacity: 0.8;
}

.uo-img-globe {
  height: 100px;
}

.uo-img-icon {
  width: 48px;
}

.uo-col-left {
  padding-right: 40px;
}

.uo-col-right {
  padding-left: 40px;
}*/

/* 詳細條列區（整齊版樣式） */
.uo-detail-dual {
  background-color: #e5f0fa;
  padding: 60px 0;
}

.uo-detail-block {
  border-bottom: 1px solid #cfd9e3;
  padding-bottom: 28px;
  margin-bottom: 28px;
}

.uo-section-title {
  color: #003b8f;
  font-weight: 900;
  font-size: 20px;
  margin-bottom: 18px;
  text-align: left;
}

.uo-subtext {
  font-size: 14px;
  font-weight: 400;
  color: #555;
  margin-left: 6px;
}

/* 每個項目：icon | (number + text) */
.uo-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 6px;
  min-height: 96px; /* 讓兩欄視覺高度一致 */
}

.uo-icon {
  width: 75px;
  flex: 0 0 64px;
  margin: 3px;
}

.uo-item-body {
  flex: 1 1 auto;
  min-width: 0;
}

.uo-number-inline {
  display: inline-flex;       /* 讓裡面元素橫排 */
  align-items: baseline;      /* 保持數字和文字對齊 */
  gap: 6px; 
  color: #f5af00;
  font-size: 32px;
  font-weight: 800;
  line-height: 1.1;
  margin: 2px 0 6px;
}

.uo-number-unit {
  color: #f5af00;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.1;
  margin: 2px 0 6px;
}

.uo-text {
  font-size: 15px;
  line-height: 1.6;
  color: #222;
  margin: 0;
  text-align: justify;
}

/* 手機優化：置中、改為直排 */
@media (max-width: 767.98px) {
  .uo-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;
  }
  /* .uo-icon {
    width: 56px;
    height: 56px;
    flex-basis: 56px;
    margin-top: 0;
  } */
  .uo-number-inline {
    font-size: 28px;
    margin: 0 0 6px;
  }
}
</style>
